import * as React from 'react';
import { observer } from 'mobx-react';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import './TimeWrapper.less';
import { InputWrapper } from '@mantine/core';

export interface ITimeWrapperProps {
    onChange: (value: any) => void;
    value?: string | null;
    error?: string;
    disabled?: boolean;
}

export const sanitizeTime = (value: string | null | undefined): string => {
    if (!value) return '00:00';
    const [rawHour, rawMinute] = value.split(':');
    const hour = String(Number(rawHour)).padStart(2, '0');
    const minute = String(Number(rawMinute)).padStart(2, '0');

    return `${hour}:${minute}`;
};

export const TimeWrapper: React.FC<ITimeWrapperProps> = observer(({ onChange, value, error, disabled }) => {
    const safeValue = sanitizeTime(value);
    return (
        <InputWrapper error={error}>
            <TimePicker
                disabled={disabled}
                clockIcon={null}
                disableClock
                onChange={(val) => {
                    const [h = '0', m = '0'] = (val || '').split(':');
                    const padded = `${String(Number(h)).padStart(2, '0')}:${String(Number(m)).padStart(2, '0')}`;
                    onChange(`${padded}:00`);
                }}
                value={disabled ? null : safeValue}
                className="custom-time-picker"
                hourPlaceholder="00"
                minutePlaceholder="00"
                format="H:mm"
                maxDetail="minute"
            />
        </InputWrapper>
    );
});
